<template>

  <m-pay-layout>
    <v-layout :column="$vuetify.breakpoint.smAndDown">
      <v-flex>
        <v-card class="mb-3 mx-2">
          <v-card-title>
            <span class="headline">Create Widget</span>
          </v-card-title>
          <v-card class="mb-3 mx-2">
            <m-pay-widget-editor
              :widget="newWidget"
              :loading="loading"
              @cancel="cancel"
              @submit="createWidget"
            />
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </m-pay-layout>

</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';
import MPayWidgetEditor from './MPayWidgetEditor';
import MPayWidgetItemsTable from './MPayWidgetItemsTable';

export default {
  name: 'MPayWidgetCreateView',

  components: { MPayWidgetEditor, MPayWidgetItemsTable },

  data: () => ({
    newWidget: {
      id: '',
      name: '',
      type: 'CHECKOUT',
      config: {
        items: [],
      },
    },
    loading: false,
  }),

  methods: {
    cancel() {
      this.$router.push({ name: 'widgets' });
    },
    createWidget(widget) {
      this.loading = true;
      axios.post(queries.createMerchantWidget(), widget)
        .then((response) => {
          this.loading = false;
          this.showSuccessMessage('Widget successfully created');
          this.fetchWidget(response.data);
        })
        .catch((e) => {
          this.handleError(e);
        });
    },
    handleError(e) {
      this.showError(e);
      this.loading = false;
    },
    fetchWidget(widgetId) {
      this.loading = true;
      this.$router.push({ name: 'widget', params: { widgetId } });
    },
    created() {
      if (this.$route.query.id) {
        this.newWidget.type = this.$route.query.type;
        this.fetchWidget(this.$route.query.id);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayWidgetCreateView.vue